import { Icons } from "assets";
import classNames from "classnames";
import { routeConstant } from "shared/routes/routeConstant";
import CustomButton from "../customButton";
import styles from "./style.module.scss";

const Footer = () => {
  return (
    <footer className="relative flex flex-col w-full items-center">
      <div className={classNames(styles.middleContainer, " w-full")}>
        <div className={classNames(styles.customContainer, "w-full")}>
          <div
            className={classNames(
              styles.getInTouchContainer,
              "flex-col md:flex-row gap-5"
            )}
          >
            <h1>Get in Touch</h1>
            <p>
              Have questions or need assistance? We are here to
              help. Reach out to us for any inquiries or support needs.
            </p>
            <CustomButton
              title="Contact Us"
              containerStyle={classNames(styles.btnStyle)}
              onClick={() => {
                window.open(routeConstant.contactUs.path, "_blank");
              }}
            />
          </div>
        </div>
      </div>
      <div
        className={classNames(
          styles.customContainer,
          "flex items-center justify-between py-10 flex-col md:flex-row gap-5 w-full",
          styles.footerBottom
        )}
      >
        <label>
          {`© ${new Date().getFullYear()} Compensation Governance Partners Inc. All Rights Reserved.`}
        </label>
        <a
          href={
            "https://www.linkedin.com/company/compensation-governance-partners/"
          }
          rel="noreferrer"
          target="_blank"
          className="flex justify-end"
        >
          <Icons.LinkedInIcon />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
